var SET_SELLER = 'SET_SELLER';
export default SET_SELLER;